import React, { useState } from 'react';
import DemoMap from './DemoMap';
import ConversionPopup from './ConversionPopup';
import DemoTooltip from './DemoTooltip';
import './MarketingLanding.css';

function MarketingLanding() {
  const [showConversionPopup, setShowConversionPopup] = useState(false);
  const [showDemoTooltip, setShowDemoTooltip] = useState(true); // Show on first visit

  const handleReviewView = () => {
    // Show conversion popup immediately
    setShowConversionPopup(true);
  };

  const handleDismissPopup = () => {
    setShowConversionPopup(false);
  };

  const handleDismissTooltip = () => {
    setShowDemoTooltip(false);
  };

  const handleSignUp = () => {
    // Redirect to signup page
    window.location.href = '/auth?view=signup';
  };

  return (
    <div className="marketing-landing">
      {/* Demo Map */}
      <DemoMap onReviewView={handleReviewView} />
      
      {/* Demo Tooltip - Show on first visit */}
      {showDemoTooltip && (
        <DemoTooltip onDismiss={handleDismissTooltip} />
      )}
      
      {/* Conversion Popup */}
      {showConversionPopup && (
        <ConversionPopup
          onDismiss={handleDismissPopup}
          onSignUp={handleSignUp}
        />
      )}
    </div>
  );
}

export default MarketingLanding;
